import { effect, inject } from '@angular/core';
import { patchState, signalStoreFeature, withHooks, withState } from '@ngrx/signals';
import { Tenant } from 'src/environments/evironment.interface';
import { AuthenticationService } from 'src/shared/services/auth/auth_service';
import { UserStore } from '../../user.store';

export type tenantState = { tenant: Tenant | null };

/**
 * @returns Signal store feature that provides the user state to another store.
 */
export function withTenant() {
  return signalStoreFeature(
    withState<tenantState>({ tenant: null }),
    withHooks({
      onInit(store, authService = inject(AuthenticationService), userStore = inject(UserStore)) {
        effect(() => {
          const user = userStore.user();

          if (user) {
            patchState(store, { tenant: authService.getActiveTenant() });
          }
        });
      },
    })
  );
}
